import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { initFAQToggles } from './utils/faqToggle.js';
import { trackPrerenderFocus } from './utils/prerenderFocus.js';

// Prerendered routes (static article HTML in #root) lose keyboard focus when React replaces the DOM; remember it.
trackPrerenderFocus();

// Create root and render app
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Initialize FAQ toggles *after* React has mounted
window.addEventListener('load', () => {
  initFAQToggles();
});
